export enum FooterType {
    NONE = 'NONE',
    THIN = 'THIN',
    LARGE = 'LARGE'
}

export function FooterTypeOf(value: string): FooterType {
    switch (value) {
        case 'NONE':
            return FooterType.NONE;
        case 'THIN':
            return FooterType.THIN;
        case 'LARGE':
            return FooterType.LARGE;
        default:
            return FooterType.NONE;
    }
}

export function valueOfFooterType(value: FooterType): string {
    return value;
}